<template functional>
  <div :class="['site-loading', { active: props.activated }]" style="z-index: 100">
    <div class="spinner">
      <div class="circle"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: ['activated']
}
</script>
